<template>
  <cyDialogCommon
    class="updateSourceDialog"
    ref="dialog"
    width="926px"
    :title="title"
    :is-show-footer="isShowFooter"
    :is-custom-footer="true"
    :btn-arr="showBtnArr"
    :is-tran-cancel="true"
    @handleCancel="handleCancel"
    @handleCommand="handleCommand"
  >
    <div class="update-content">
      <SelectDatabase
        v-show="page === 1"
        ref="selectDatabase"
        :server-data="serverData"
        @selectServer="selectServer"
      />
      <ConfigDatabase
        v-show="page === 2"
        ref="configDatabase"
        :database="database"
        :encoding-list="encodingList"
        :set-info="selectedServer"
        @saveInfo="saveInfo"
      />
    </div>
  </cyDialogCommon>
</template>
<script>
import { toTopAnimation } from '@common/util.js'
import SelectDatabase from './selectDatabase'
import ConfigDatabase from './configDatabase'
import database from './database'
export default {
  name: 'DataDialog',
  components: {
    SelectDatabase,
    ConfigDatabase
  },
  props: {
    isAlter: {
      type: Boolean,
      default: false
    },
    serverData: {
      type: Array,
      default: () => []
    },
    encodingList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    title() {
      return this.isAlter ? '编辑数据源配置' : '新增数据源配置'
    },
    isShowFooter() {
      return this.page !== 1
    },
    btnArr() {
      return [
        {
          name: '取消',
          label: 'cancel',
          show: true
        },
        {
          name: '上一步',
          label: 'prev',
          show: !this.isAlter
        },
        {
          name: '保存',
          label: 'save',
          show: true
        },
        {
          name: '保存并配置业务库',
          label: 'saveAndConfig',
          show: this.$route.path === '/etl/business/ds'
        }
      ]
    },
    showBtnArr() {
      return this.btnArr.filter(item => item.show)
    }
  },
  data() {
    return {
      database: database,
      selectedServer: {},
      page: this.dialogPage
    }
  },
  methods: {
    init(selectedData) {
      this.page = 1
      if (selectedData) {
        this.page = 2
        this.$nextTick(() => {
          this.$refs.configDatabase.editData(selectedData)
        })
      }
      this.toTopAnimation()
    },
    selectServer(item) {
      this.selectedServer = Object.assign({}, item)
      this.page = 2
      this.toTopAnimation()
      this.$refs.configDatabase.initData(item.typeId)
    },
    handleCancel() {
      this.$store.commit('dataCenter/updateIsSelectedSource', false)
    },
    handleCommand(value) {
      switch (value) {
        case 'prev':
          this.page -= 1
          this.toTopAnimation()
          break
        case 'save':
          this.$refs.configDatabase.submitForm()
          break
        case 'saveAndConfig':
          this.$refs.configDatabase.submitForm(true)
          break
        default:
          this.$refs.dialog.closeDialog()
          break
      }
    },
    saveInfo({ params, isConfig }) {
      this.$emit('updateSource', { params: params, isConfig: isConfig, isAlter: this.isAlter })
    },
    toTopAnimation() {
      if (document.querySelector('.updateSourceDialog .el-dialog__body .update-content')) {
        toTopAnimation('.updateSourceDialog .el-dialog__body .update-content')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.updateSourceDialog {
  /deep/ .cy-dialog-common {
    .el-dialog__header {
      margin: 0 30px;
      padding: 20px 10px;
      border-bottom: 1px solid #e6e6e6;
    }
    .el-dialog__body {
      padding:0;
      .update-content {
        max-height: calc(100vh - 200px);
        padding:0 30px 20px;
        overflow-y: auto;
      }
    }
    .el-dialog__footer {
      margin: 0;
    }
  }
}
</style>
